export const getSideNavActiveHref = (pathname: string): string =>
  pathname.startsWith('/services')
    ? // 'Service information' link should stay active in the side nav for service sub-pages
      '#/services'
    : pathname.startsWith('/packages')
    ? '#/packages'
    : `#${pathname}`;
